/**************************************
 ** AtlasLatitudePriorityQueue
 *
 *  Default priority queue will load a specified latitude first in a single batch, followed by batches of 10
 *  for each image resolution path passed in.
 *
 *  The contract is having a member _batches and a method createBatches that takes a list of images - that has an array of
 *  objects with index (numerical index into _batches array), name (friendly name), complete (boolean flag if
 *  batch is complete), onComplete (function to call when batch is loaded), onCompleteParameters (array of items
 *  that will be passed as an argument to the function specified on onComplete, images (array of image objects).
 *
 *  The images array contains objects with resolution (index into the resolution paths where this image was
 *  loaded from), index (the string image index e.g., C01), src (the full path to the image), complete (if the
 *  image has been loaded)
 ***************************************/
define('atlas/AtlasPriorityQueue', [], function() {
    'use strict';

    var AtlasPriorityQueue = function(pathAdapter, batchSize, startResolution) {
        this._pathAdapter = pathAdapter;
        this._batchSize = batchSize;
        this._startResolution = startResolution || 0;
        this._batches = [];
    };

    AtlasPriorityQueue.prototype.createBatches = function(imageList, identifier) {
        if (!identifier) {
            //just assign a new unique string if one is not provided
            identifier = new Date();
        }
        this._createBatches(this._pathAdapter, imageList, this._batchSize, identifier);
    };

    AtlasPriorityQueue.prototype._createBatches = function(pathAdapter, imageList, batchSize, identifier) {
        if (imageList.length === 0) {
            return;
        }

        //setup intelligent defaults
        if (!batchSize || batchSize <= 0) {
            batchSize = 10;
        }

        //empty out any existing batches
        this._batches = [];

        //fill in the batches
        var count = 0;
        var currentBatch = {
            identifier: identifier,
            index: this._batches.length,
            name: 'Batch #' + this._batches.length,
            complete: false,
            onComplete: null,
            onCompleteParameters: null,
            images: []
        };

        for (var p = 0; p < pathAdapter.getAvailableResolutionsCount(); ++p) {
            for (var i = 0; i < imageList.length; ++i) {
                //add image to batch
                currentBatch.images.push({
                    resolution: this._startResolution + p,
                    index: imageList[i].originalImageIndex,
                    src: pathAdapter.getImagePath(imageList[i].originalImageIndex, p),
                    complete: false,
                    face: imageList[i].face
                });

                count++;

                if ((count % batchSize) === 0) {
                    //add batch
                    this._batches.push(currentBatch);
                    currentBatch = {
                        identifier: identifier,
                        index: this._batches.length,
                        name: 'Batch #' + this._batches.length,
                        complete: false,
                        onComplete: null,
                        onCompleteParameters: null,
                        images: []
                    };
                    //reset the count
                    count = 0;
                }
            }
        }

        //add the last batch
        if (currentBatch.images.length > 0) {
            //add partial final batch
            this._batches.push(currentBatch);
        }
    };

    return AtlasPriorityQueue;
});
